import * as tslib_1 from "tslib";
import { CompositeChunkBase } from "./CompositeChunkBase";
// TODO: shadow mappers references in materials should be an interface so that this class should NOT extend ShadowMapMethodBase just for some delegation work
/**
 * ShadowNearChunk provides a shadow map method that restricts the shadowed area near the camera to optimize
 * shadow map usage. This method needs to be used in conjunction with a NearDirectionalShadowMapper.
 *
 * @see away.lights.NearDirectionalShadowMapper
 */
var ShadowNearChunk = (function (_super) {
    tslib_1.__extends(ShadowNearChunk, _super);
    /**
     * Creates a new ShadowNearChunk.
     */
    function ShadowNearChunk(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        return _this;
    }
    /**
     * @inheritDoc
     */
    ShadowNearChunk.prototype._initConstants = function () {
        _super.prototype._initConstants.call(this);
        var fragmentData = this._shader.fragmentConstantData;
        var index = this._fragmentConstantsIndex;
        fragmentData[index + 2] = 0;
        fragmentData[index + 3] = 1;
    };
    /**
     * @inheritDoc
     */
    ShadowNearChunk.prototype._initVO = function (chunkVO) {
        _super.prototype._initVO.call(this, chunkVO);
        chunkVO.needsProjection = true;
    };
    /**
     * @inheritDoc
     */
    ShadowNearChunk.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = _super.prototype._getFragmentCode.call(this, targetReg, registerCache, sharedRegisters);
        var dataReg = registerCache.getFreeFragmentConstant();
        var temp = registerCache.getFreeFragmentSingleTemp();
        this._fragmentConstantsIndex = dataReg.index * 4;
        code += "abs " + temp + ", " + sharedRegisters.projectionFragment + ".w\n" +
            "sub " + temp + ", " + temp + ", " + dataReg + ".x\n" +
            "mul " + temp + ", " + temp + ", " + dataReg + ".y\n" +
            "sat " + temp + ", " + temp + "\n" +
            "sub " + temp + ", " + dataReg + ".w," + temp + "\n" +
            "sub " + targetReg + ".w, " + dataReg + ".w," + targetReg + ".w\n" +
            "mul " + targetReg + ".w, " + targetReg + ".w, " + temp + "\n" +
            "sub " + targetReg + ".w, " + dataReg + ".w," + targetReg + ".w\n";
        return code;
    };
    /**
     * @inheritDoc
     */
    ShadowNearChunk.prototype._setRenderState = function (renderable, projection) {
        // todo: move this to activate (needs camera)
        var near = projection.near;
        var d = projection.far - near;
        var maxDistance = this._method.castingLight.shadowMapper.coverageRatio;
        var minDistance = maxDistance * (1 - this._fadeRatio);
        maxDistance = near + maxDistance * d;
        minDistance = near + minDistance * d;
        var fragmentData = this._shader.fragmentConstantData;
        var index = this._fragmentConstantsIndex;
        fragmentData[index] = minDistance;
        fragmentData[index + 1] = 1 / (maxDistance - minDistance);
        _super.prototype._setRenderState.call(this, renderable, projection);
    };
    return ShadowNearChunk;
}(CompositeChunkBase));
export { ShadowNearChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/ShadowNearChunk.js